var version = "5.0.0-alpha.2";

export { version };
